import { FC } from "react";
import Comp from "./Comp";

export interface IProps {}

const Login: FC = () => {
  return <Comp />;
};

export default Login;
